module.exports = __webpack_public_path__ + "img/undraw_my_documents_ym8x.58a871cc.svg";